<div class="mt-1">
  <div class="welcome-screen mt-1 container-sm">
    <div class="{{hasConfigDragRubric ? 'mt-4': 'row justify-content-center'}}">
      <div class="{{hasConfigDragRubric  ? '': 'col-md-12'}}">
        <div class="{{hasConfigDragRubric  ? 'card custom-card': 'card shadow-lg p-5 text-center'}}">
          <div *ngIf="acceptRubricPlacementChecked " class="mt-2 card-body">
            <app-alert-add-document
              [message]="loadMessageHtml"></app-alert-add-document>
          </div>
          <div class="text-center">
            <h4
              class="title mb-4 {{hasConfigDragRubric && !acceptRubricPlacementChecked ? 'mt-5': ''}}">{{ "TITLE.SIGNATURE-DOCUMENTS" | translate }}</h4>
            <div>
              <label class="font-weight-bold">{{ "LABEL.FLOW" | translate }}</label> :
              {{ document._more.workflowDescription }}
            </div>
            <div>
              <label class="font-weight-bold">{{ "LABEL.SUBJECT" | translate }}</label> :
              {{ document.subject }}
            </div>
            <div><label class="font-weight-bold">
              <i class="fa fa-folder-open text-primary gap-2"></i> {{ "Documentos para firma" }}
              ({{ resourceList.length }})
            </label></div>


            <div class="documents-panel">

              <div class="documents-tabs">
                <div *ngFor="let item of resourceList"
                     (click)="setUrlDoc(item)"
                     class="document-tab"
                     [class.active]="item===resource"
                     [class.checked]="wasChecked(item)">
                  <div class="doc-icon">
                    <i class="fa"
                       [ngClass]="{
                        'fa-eye':item===resource,
                        'fa-check-circle':wasChecked(item)&&item!==resource,
                        'fa-file-pdf text-danger':item!==resource
                   }">
                    </i>
                  </div>

                  <div class="doc-text">
                    <div class="doc-title">
                      {{ cutFileName(item.fileName) }}
                    </div>
                    <small>
                      <ng-container *ngIf="item===resource">
                        Visualizando
                      </ng-container>

                      <ng-container *ngIf="wasChecked(item) && item!==resource">
                        Revisado
                      </ng-container>

                      <ng-container *ngIf="!wasChecked(item) && item!==resource">
                        Ver
                      </ng-container>
                    </small>
                  </div>
                </div>
              </div>
            </div>

            <div class="documents-panel" *ngIf="acceptRubricPlacementChecked">

              <!-- Seleccionar todos -->
              <div class="documents-header">
                <label class="select-all">
                  <input
                    type="checkbox"
                    [checked]="wasAllSelected1()"
                    (change)="addOrRemoveAll($event)">
                  <span>Seleccionar todos</span>
                </label>
              </div>

              <!-- Lista de documentos -->
              <div class="documents-tabs">

                <div
                  *ngFor="let item of resourceList; let i = index"
                  class="document-tab"
                  [class.active]="item === resource"
                  [class.checked]="wasChecked(item)"
                  (click)="setUrlDoc(item)">
                  <div class="doc-icon">

                    <i
                      class="fa"
                      [ngClass]="{  'fa-eye': item === resource,
                      'fa-check-circle': wasChecked(item) && item !== resource,
                      'fa-file-pdf text-danger': !wasChecked(item) && item !== resource
                       }">
                    </i>

                  </div>

                  <div class="doc-text">
                    <div class="doc-title">
                      {{ cutFileName(item.fileName) }}
                    </div>
                    <small>

                      <ng-container *ngIf="item===resource">
                        Visualizando
                      </ng-container>

                      <ng-container *ngIf="wasChecked(item) && item!==resource">
                        Será firmado
                      </ng-container>

                      <ng-container *ngIf="!wasChecked(item) && item!==resource">
                        No será firmado
                      </ng-container>

                    </small>

                  </div>

                  <!-- Checkbox -->
                  <div class="doc-check">
                    <input
                      type="checkbox"
                      [checked]="wasSelected2(item)"
                      (click)="$event.stopPropagation()"
                      (change)="addRemoveResource($event,item)">
                  </div>
                </div>

              </div>

            </div>

            <br>
          </div>
          <div class="{{hasConfigDragRubric ?  'custom-container-2': ''}}">
            <div class="row alert {{alertType}} custom-alert" *ngIf="showError" id="customAlert">
                                <span class="alert-icon">
                                    <i
                                      class="fa-1x  {{icon}} {{alertType === 'alert-danger' ? 'text-danger': (this.alertType ==='alert-warning' ? 'text-warning': 'text-info')}}"></i>&nbsp;</span>
              <div class="alert-content {{alertType}} font-weight-normal">
                <div [innerHTML]="messageAlert | translate"></div>
              </div>
            </div>
            <div class="{{hasConfigDragRubric ? 'custom-mw-980':''}}">
              <div class="{{hasConfigDragRubric ? 'pdf-box':'' }}">
                <app-pdf-viewer *ngIf="!reloadingPdf"
                                [urlStream]="urlStream"
                                [rubricSrc]="defaultRubricSrc"
                                [showRubric]="hasConfigDragRubric &&  this.resource.sign"
                                [resource]="this.resource"
                                [signComplete]="this.signCompleted"
                                [signatureDescriptions]="getListSignatureDescription()"
                                [typeSignature]="typeSignature"
                                [personId]="personId"
                                [isUser]="false"
                                [isLastOperator]="isLastOperator"
                                (rubricDragged)="rubricDragEnd($event)"
                                [eventDragging]="eventsSubject.asObservable()">
                </app-pdf-viewer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="text-center floating-bar">
    <button class="floating-button font-weight-bold" (click)="signDocuments()">
      <i class="fas fa-signature"></i> {{ "TITLE.SIGN-DOCUMENT" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading || loadingSign || reloadingPdf"></app-loading>
